import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">为什么选择我们</h2>
          <p className="text-sm md:text-base text-foreground-400">用心做内容，用速度说话，做最懂你的国产吃瓜视频平台</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/60 p-8 text-center hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-5 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-400 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}